import lodash from 'lodash'

const MANDATORY_KEYS = [
  'api.base_url',
  'root_path',
  'asset_path'
]

let ENV = {
  dev: false,
  NODE_ENV: process.env.NODE_ENV,
  PUBLIC_URL: process.env.PUBLIC_URL,

  log: {
    enabled: false,
    contexts: {
      action: false,
      reducer: false,
      api: false,
      store: false,
    }
  },

  api: {
    base_url: 'https://www.yettel.rs/stage2-bff',
    site_base_url: 'https://www.yettel.rs/lweb1-staging',
    siteHeaderEndpoint: '/pageShell',
    headerEndpoint: '/pages/header',
    loginEndpoint: '/user/login',
    logoutEndpoint: '/user/logout'
  },
  root_path: 'https://www.yettel.rs/',
  webshop_path: '/staging/webshop2',
  asset_path: '/assets/img',
  domain: 'https://www.yettel.rs/',
  prefixUrl: 'lweb1-staging',
  tnAccountClientId: 'webshop-staging-new-public',
  tnAccountDomain: 'https://www.yettel.rs/staging/nalog',
  tnAccountClientSecret: '123456',
  links: {
    wsUrl: 'https://www.yettel.rs/staging/webshop2',
    mojTelenorUrl: 'https://www.yettel.rs/yettel',
    ysdUrl: "https://shopping.yettel.rs/",
    tnAccountSettingUrl: 'https://www.yettel.rs/nalog/app/',
    tnAccountLogoutUrl: "https://www.yettel.rs/staging/webshop/session-logout/",
    cartOverviewUrl: "https://www.yettel.rs/staging/webshop2/sr/Privatni-korisnici/Kupovina",
    businessPortalUrl: "https://www.yettel.rs/biznisportal/",
    hipernetUrl: "https://ytl.rs/hnapp"
  }
}

ENV.img_path = ENV.root_path + ENV.asset_path

ENV.dev = ENV.NODE_ENV === 'development'

// Validate that ENV is correct

const missingKeys = lodash.reduce(MANDATORY_KEYS, (missing, key) => {
  const value = lodash.get(ENV, key)
  if (value === undefined || value === null) {
    missing = missing || []
    missing.push(key)
  }
  return missing
}, null)
if (missingKeys) {
  throw new Error(`The following values are missing from your env: `)
}

export default ENV
